import { App } from 'vue'
import FlipCard from './LpFlipCard.vue'

FlipCard.install = (Vue: App) => {
  Vue.component(FlipCard.name, FlipCard)
}

export default FlipCard
